export default __webpack_public_path__ + "static/media/PDFtest.3132cbc8.pdf";